module.exports = __webpack_public_path__ + "static/media/hian-oliveira-n_L_ppO4QtY-unsplash@3x.4a105028.png";